<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .background-section {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(13px);
    width: 100%;

    .background-section-header {
      @include mixins.body2();
      @include colors.color(primary_90);
      margin: 0;
      padding-left: utils.in_rem(17px);
      text-transform: uppercase;
    }

    .items-container {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(19.5px);
      width: 100%;

      .experience-group {
        display: flex;
        flex-direction: column;
        gap: utils.in_rem(20px);
        width: 100%;

        .experience-group-item {
          display: flex;
          gap: utils.in_rem(12px);
          padding-left: utils.in_rem(17px);

          &.has-dot {
            padding-left: 0;
          }
        }

        .dot {
          @include colors.background-color(interfaceSwGrey_20);
          border-radius: 50%;
          flex-shrink: 0;
          height: utils.in_rem(5px);
          margin-top: utils.in_rem(7.25px);
          position: relative;
          transform-style: preserve-3d;
          width: utils.in_rem(5px);

          &::before {
            @include colors.background-color(interfaceSwGrey_20);
            content: "";
            display: block;
            height: 400px;
            left: 50%;
            position: absolute;
            transform: translateX(-50%) translateZ(-1px);
            width: 1px;
          }

          &.last-dot::before {
            background-color: white;
            width: 2px;
          }
        }
      }
    }

    .no-data-wrapper {
      align-items: center;
      display: flex;
      justify-content: center;
      padding: utils.in_rem(24px) 0;
      width: 100%;

      .no-data-text {
        @include colors.color(textGrey);

        .no-data-header {
          text-align: center;
        }

        span {
          @include mixins.body2();
          text-align: center;
        }
      }
    }
  }
</style>

<script>
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import NoData from "@sourcewhale/shared/svelte-design-system/components/atoms/NoData.svelte";
  import ExperienceItem from "./ExperienceItem.svelte";

  let { experience } = $props();

  // Group experience items by company
  let experienceGroups = $derived.by(() => {
    const groups = [];
    let currentGroup = [];

    experience.forEach((exp, index) => {
      if (currentGroup.length) {
        const previousExp = currentGroup.at(-1);
        if (exp.company === previousExp.company) {
          currentGroup.push(exp);
        } else {
          groups.push([...currentGroup]);
          currentGroup = [exp];
        }
      } else {
        currentGroup.push(exp);
      }

      if (index === experience.length - 1 && currentGroup.length) {
        groups.push([...currentGroup]);
      }
    });

    return groups;
  });
</script>

<div class="background-section">
  <h3 class="background-section-header">Work Experience</h3>
  {#if experience.length}
    <div class="items-container">
      {#each experienceGroups as group}
        <div class="experience-group">
          {#each group as exp, expIndex (exp.startedAt + exp.company + exp.role)}
            <div
              class={["experience-group-item", group.length > 1 && "has-dot"]}
            >
              {#if group.length > 1}
                <div
                  class={["dot", expIndex === group.length - 1 && "last-dot"]}
                ></div>
              {/if}
              <ExperienceItem experience={exp} />
            </div>
          {/each}
        </div>
      {/each}
    </div>
  {:else}
    <div class="no-data-wrapper">
      <NoData>
        <div slot="icons" class="icons">
          <IconScale
            backgroundColor="interfaceSwGrey_10"
            color="interfaceSwGrey_20"
            class="fa-solid fa-briefcase"
            size="xl"
          />
        </div>
        <div slot="text" class="no-data-text">
          <h3 class="no-data-header">No experience available</h3>
          <span>This contact has no work experience</span>
        </div>
      </NoData>
    </div>
  {/if}
</div>
